import { render, staticRenderFns } from "./IlluCours10jours.vue?vue&type=template&id=6dc0e5ee&"
import script from "./IlluCours10jours.vue?vue&type=script&lang=js&"
export * from "./IlluCours10jours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports